'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './quickbooks-list.routes';

export class QuickbooksListComponent {
  constructor(IntegrationService, Config, $timeout) {
    'ngInject';

    this.loading = true;
    this.noData = true;
    this.$timeout = $timeout;

    this.IntegrationService = IntegrationService;
    this.showRunningBalance = Config.getModuleConfig(Config.Modules.Quickbooks).getShowRunningBalance();

    this.data = {};
    this.balances = {};
    this.property = "";

    IntegrationService.queryProperties(properties => {

      this.properties = properties.map(ppty => {
        ppty.name = ppty.propertyAddress + " / Lot# " + ppty.lotNo;
        return ppty;
      });

      if (properties.length) {
        this.selectedProperty = properties[0].propertyId;
        this.applyPropertySelect();
      } else {
        this.loading = false;
        this.noData = true;
      }
      
    }, _=> {
      this.loading = false;
      this.noData = true;
    });

  }

  applyPropertySelect() {
    let property = this.properties.find(ppty => ppty.propertyId == this.selectedProperty);
    this.property = property.propertyAddress + " / Lot# " + property.lotNo;

    this.loading = true;
    this.noData = true;
    this.data = {}; // reset
    this.balances = {}; // reset

    this.IntegrationService.queryQuickbookBalances({propertyId: this.selectedProperty}, data => {

      this.noData = !!!data.length;
      
      data.forEach(entry => {
        if (!this.data[entry.account]) {
          this.data[entry.account] = [];
        }

        this.data[entry.account].push(entry);

        if (!this.balances[entry.account]) {
          this.balances[entry.account] = 0;
        }

        this.balances[entry.account] += entry.amount;
      });

      this.accounts = Object.keys(this.data);

      if (this.showRunningBalance) {
        this.accounts.forEach(acc => {
          for (let i=0; i<this.data[acc].length; i++) {
            if (i===0) {
              this.data[acc][i].balance = this.data[acc][i].amount
            } else {
              this.data[acc][i].balance = this.data[acc][i-1].balance + this.data[acc][i].amount;
            }
          }
        });
      }

      this.loading = false;
      this.$timeout(_=>{
        this.active=0
      },0);
    }, _=> {
      this.loading = false;
      this.noData = true;
    });
  }
}

export default angular.module('conduu.quickbooksList', [uiRouter])
  .config(routes)
  .component('quickbooksList', {
    template: require('./quickbooks-list.html'),
    controller: QuickbooksListComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/user/quickbooks-list/quickbooks-list.component.js